import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React, { memo } from 'react';
export interface ButtonsListContainerProps {
  buttonsList: Array<RMCustomButtonProps | React.ReactNode>;
  containerStyleClass?: string;
  containerStyle?: React.CSSProperties;
  contentOrientation?: 'Vertical' | 'Horizontal';
  marginBetweenItems?: string | number;
}
const renderButtons = (_buttonsList, marginBetweenItems) =>
  _buttonsList.map((item, index) => {
    const marginRight =
      index < _buttonsList.length - 1 && marginBetweenItems ? marginBetweenItems : 0;
    const { contentContainerStyle, ...rest } = item;
    return React.isValidElement(item) == false ? (
      <RMCustomButton
        id={`buttons-list-item-${index}`}
        contentContainerStyle={{ marginRight, ...contentContainerStyle }}
        key={`buttons-list-index-${index}`}
        {...rest}
      />
    ) : (
      {
        ...(item as React.ReactElement),
        props: { ...item.props, style: { ...item.props.style, marginRight } },
        key: `buttons-list-index-${index}`,
      }
    );
  });
const flexDirection = {
  Horizontal: 'flex-row',
  Vertical: 'flex-column',
};
function ButtonsListContainer(props: ButtonsListContainerProps) {
  const {
    buttonsList,
    containerStyleClass,
    containerStyle,
    contentOrientation = 'Horizontal',
    marginBetweenItems,
  } = props;
  return (
    <div
      id="index-render-buttons-list-container"
      style={{ justifyContent: 'space-between', ...containerStyle }}
      className={`d-flex flex-space-between h-100 
     ${flexDirection[contentOrientation]} ${containerStyleClass}`}
    >
      {renderButtons(buttonsList, marginBetweenItems)}
    </div>
  );
}
export default memo(ButtonsListContainer);
